import { AssignedPermission } from '@/apis/gin/boundary-database/users/assignments.dto';
import { Boundary, Space } from '@/app/login/typings';

export enum Role {
  CMS_ADMIN = 'CMS_ADMIN',
  ACCOUNT_ADMIN = 'ACCOUNT_ADMIN',
  DEPARTMENT_MANAGER = 'DEPARTMENT_MANAGER',
  DEPARTMENT_USER = 'DEPARTMENT_USER',
  // new type
  PROGRAM_MANAGER = 'PROGRAM_MANAGER', // replace ACCOUNT_ADMIN, it is space owner and higher than ACCOUNT_ADMIN
  PROJECT_MANAGER = 'PROJECT_MANAGER', // it is similar ACCOUNT_ADMIN, it is include in the boundary.
  DATA_COLLECTOR = 'DATA_COLLECTOR', // it is similar DEPARTMENT_USER, it is include in the boundary.
}

export const PROJECT_ADMIN_ROLES = [Role.PROGRAM_MANAGER, Role.PROJECT_MANAGER];

export interface UserInfo {
  id: string;
  role: Role;
  email: string;
  firstName: string;
  lastName: string;

  isInBoundaryScope: boolean;
  boundaryId: string;
  boundaryIds: string[];

  departmentId: string;
  assignedPermissions: AssignedPermission[];
  boundary: Boundary[];
  space: Space[];

  spaceId: string; // when in space scope
  boundaryProjectId: string; // when in boundary project scope
}
